export default __webpack_public_path__ + "static/related-books-6ba90f97267a18bb8caca693af6c3b5b.png";